import React from 'react';
import '../App.css';
import { Button } from './Button';
import './HeroSection.css';
import { Link } from 'react-router-dom';

function HeroSection() {
  return (
    <div className='hero-container'>
      <h1>Sharen Cain FCCA</h1>
      <p>Your local accountant that speaks your language</p>
      <div className='hero-btns'>
        <Button
          className='btns'
          buttonStyle='btn--primary'
          buttonSize='btn--large'
          link='mailto:sharencainfcca@gmail.com'
        >
          Send An Email
        </Button>
      </div>
      <div className='phonelnks'>
        <p>
          Office:{' '}
          <Link to='tel:01233877878' className='phonelnk'>
            01233 877878
          </Link>
        </p>
        <p>
          Mobile:{' '}
          <Link to='tel:07889630885' className='phonelnk'>
            07889 630885
          </Link>
        </p>
      </div>
    </div>
  );
}

export default HeroSection;